<template>
  <div>
    <div v-show="ratingModal">
      <ith-rating @updateRating="handleRating" />
    </div>

    <div class="container">
      <ith-alert />
      <h2 class="title">Reviews</h2>
      <div v-if="article" class="articles-grid">
        <div class="article--item">
          <div class="article--item-box">
            <span class="article--title"
              ><h1>{{ article.title }}</h1>
            </span>

            <div class="share-article">
              <div class="sharethis-inline-share-buttons"></div>
            </div>
            <div class="article--subhader">
              <div class="article--subhader-autor">
                <div class="article--autor">{{ article.author }}</div>
                <div class="article--date">
                  {{ article.date | date_articles }}
                </div>
              </div>
              <div class="article--rating">
                <div class="rating--title">
                  <!-- <span class="rating" v-if="rating"> -->
                  <span class="rating">
                    <div class="text-center">User Rating</div>
                    <div class="text-center">{{ rating }}</div>
                    <div>
                      <star-rating
                        class="item-center"
                        v-model="rating"
                        :star-size="20"
                        :border-width="1"
                        :show-rating="false"
                        :increment="0.5"
                        inactive-color="#efefef"
                        :rounded-corners="true"
                        :star-points="[
                          23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50,
                          36, 34, 46, 19, 31, 17,
                        ]"
                        read-only
                      ></star-rating>
                    </div>
                    <div class="movie-detail--icon">
                      <div>
                        <button
                          class="movie-detail--icon--button"
                          @click.prevent="makeRating()"
                        >
                          <font-awesome-icon icon="star" />
                        </button>
                        <div class="help-text">Rate it</div>
                      </div>
                      <div>
                        <button
                          @click.prevent="setWatchlist(show)"
                          class="movie-detail--icon--button"
                          :class="{
                            active: show.watchlist,
                            backgroundActive: show.watchlist,
                          }"
                        >
                          <font-awesome-icon
                            v-if="show.watchlist"
                            icon="check"
                          />
                          <font-awesome-icon v-else icon="plus-circle" />
                        </button>
                        <div class="help-text">Watchlist</div>
                      </div>
                      <div>
                        <button
                          @click.prevent="setWatched(show)"
                          class="movie-detail--icon--button"
                          :class="{
                            active: show.watched,
                            backgroundActive: show.watched,
                          }"
                        >
                          <font-awesome-icon icon="eye" />
                        </button>
                        <div class="help-text">Watched</div>
                      </div>
                    </div>
                  </span>
                  <!-- <span class="rating" v-else> N/A </span> -->
                </div>
              </div>
            </div>
            <p class="article--content" v-html="article.content"></p>
          </div>
          <div class="">
            <ith-detail-comments />
          </div>
        </div>

        <div class="asside">
          <ith-table-o-t-t-platforms />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import { mapState } from "vuex";

export default {
  components: {
    StarRating,
  },
  computed: mapState(["alert", "show", "ratingModal"]),
  data: () => ({
    params: {
      articleId: "",
    },
    article: {
      title: "",
      author: "",
      date: "",
      content: "",
      description: "",
      imageUrl: "",
    },
    rating: 0,
  }),
  metaInfo() {
    return {
      // title: `OTT Watchlist - ${this.$route.params.slug}`,

      meta: [
        {
          vmid: "title",
          name: "title",
          content: `${this.article.title} - OTT Watchlist`,
        },
        {
          vmid: "description",
          name: "description",
          content: this.article.description.substr(0, 180),
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content: this.article.description.substr(0, 180),
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          property: "twitter:card",
          content: "summary",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content: `${this.article.title} - OTT Watchlist`,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          property: "twitter:image",
          content: `${this.article.imageUrl}`,
        },
      ],
    };
  },
  mounted() {
    let shareit = document.createElement("script");
    shareit.setAttribute(
      "src",
      "https://platform-api.sharethis.com/js/sharethis.js#property=5fbd983fc58f770012701424&product=sop"
    );
    shareit.setAttribute("async", true);
    document.head.appendChild(shareit);
    this.params.articleId = this.$route.params.id;
    this.$Parse.Cloud.run("getArticleDetail", this.params)
      .then((res) => {
        this.article = res;
        if (res.show.rating) this.rating = res.show.rating;
        else this.rating = "N/A";
        if (this.user == null || !this.user.username) {
          this.$set(this.article.show, "watchlist", false);
          this.$set(this.article.show, "watched", false);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.$store.commit("EDIT_SHOW", this.article.show);
        if (this.user == null || !this.user.username) {
          this.showWatchedListLocal();
        }
      });
  },

  methods: {
    makeRating() {
      this.$store.commit("toggleRatingModal");
    },
    handleRating(value) {
      this.rating = value;
    },
    async setWatched(item) {
      this.$store.commit("EDIT_WATCHED_SHOW", !item.watched);
      this.$store.dispatch("SET_WATCHED", item);
    },
    async setWatchlist(item) {
      this.$store.commit("EDIT_INWATCHLIST_SHOW", !item.watchlist);
      this.$store.dispatch("SET_WATCHLIST", item);
    },
    showWatchedListLocal() {
      this.watchlistLocal = JSON.parse(
        localStorage.getItem("OTT/Watchlist/Guest")
      );
      if (this.watchlistLocal != null) {
        const index = this.watchlistLocal.findIndex(
          (element) => element.showId == this.show.id
        );
        if (index != -1) {
          this.$store.commit("EDIT_INWATCHLIST_SHOW_FORCE", true);
        }
      }

      this.watchedLocal = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
      if (this.watchedLocal != null) {
        const index = this.watchedLocal.findIndex(
          (element) => element.showId == this.show.id
        );
        if (index != -1) {
          this.$store.commit("EDIT_WATCHED_SHOW_FORCE", true);
        }
      }
    },
  },
};
</script>

<style scoped>
.title {
  margin-left: 15px;
  font-size: 35px;
}
.articles-grid {
  display: grid;
  grid-template-columns: 70% 27%;
  column-gap: 3%;
}

.article--item {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
}
.article--item-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  padding-left: 20px;
  padding-right: 15px;
  border-radius: 15px;
  background-color: white;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.article--title {
  padding-left: 20px;
  margin: 2% 0;
  font-weight: 600;
  color: #284367;
  font-size: 0.9em;
  line-height: 30px;
}
.article--title > h1 {
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.article--subhader {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #939292;
  padding-top: 20px;
}

.article--autor {
  padding-left: 20px;
  color: #283441;
  font-weight: 600;
  color: #284367;
}
.article--date {
  padding-left: 20px;
  font-size: 0.9em;
  color: #738092;
}
.article--content {
  padding: 20px 20px 50px 20px;
  color: #738092;
  overflow: hidden;
}

.share-article {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.rating--title {
  font-weight: 600;
  color: #284367;
  display: grid;
  justify-content: end;
  align-items: flex-end;
  margin-right: 20px;
}

.movie-detail--icon {
  display: grid;
  grid-template-columns: repeat(3, 57px);
  gap: 10px;
  align-content: center;
  justify-content: center;
  justify-items: center;
  margin: 12px 0;
}
.movie-detail--icon > div {
  justify-self: center;
  display: grid;
  grid-template-columns: 100%;
  gap: 10px;
  align-content: center;
  justify-items: center;
}
.movie-detail--icon--button {
  align-self: center;
  height: 35x;
  width: 37px;
  border: 0px;
  border-radius: 6px;
  background-color: #284367;
  color: #939292;
  padding: 9px 10px;
  font-size: 1em;
  cursor: pointer;
  text-align: center;
}

.active {
  color: white !important;
}

.backgroundActive {
  background-color: #94c659;
}
.text-center {
  text-align: center;
}
.item-center {
  display: grid;
  justify-content: center;
}
.help-text {
  text-align: center;
  font-weight: 400;
  font-size: 0.7em;
}
@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1024px) and (max-width: 1264px) {
}
@media (min-width: 1020px) and (max-width: 1024px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .articles-grid {
    grid-template-columns: 95%;
    justify-content: center;
    row-gap: 50px;
  }
}

@media (max-width: 600px) {
  .article--subhader {
    grid-template-columns: 100%;
  }

  .article--rating {
    justify-self: center;
  }
  .articles-grid {
    grid-template-columns: 95%;
    justify-content: center;
    row-gap: 50px;
  }
}
</style>